import React, { useRef, useState, useEffect, useCallback, Component } from 'react';
import StepsVisualizer from "components/mix/StepsVisualizer.js"
import {getProjects} from 'components/sequences2/getProjects.js';
import StonkTicker from './StonkTicker.js';
import {getTranspose} from './getTranspose.js';
import Grid from './Grid.js';
import {connect} from 'react-redux';
import StepData from "pattern/StepData.js"
import {useLandingSequence} from './useLandingSequence.js';
import Resolution from "engine/Resolution.js";
import RecordedTrigger from 'keyboard/RecordedTrigger.js';
const RESOLUTION = new Resolution(16, false);

const LandingAbout = (props) => {
    let [play, setPlay] = useState(false);
    let counter = useRef(0);

    let {sequencerEngine} = useLandingSequence({...props, skipSampleRate: true});
    let [part, setPart] = useState(0);
    let {scrollContainer, isRecording} = props;

    useEffect(() => {
        window.addEventListener("scroll", onScroll, {capture: true});
    }, [setPart, part, sequencerEngine]);

    const pause = useCallback(() => {
        sequencerEngine.stop();
        setPlay(false);
    }, [sequencerEngine, setPlay]);

    const onScroll = useCallback((e) => {
        if (sequencerEngine && sequencerEngine.playing) {
            if (counter.current++ % 4 === 0) {
                let ratio = e.target.scrollTop / window.innerHeight;
                let vol = getVolume(e.target.scrollTop, -40, -4, window.innerHeight);
                /*
                sequencerEngine.tracks[2].faderNode.gain.rampTo(1 - ratio, 0.01);
                sequencerEngine.tracks[3].faderNode.gain.rampTo(1 - ratio, 0.01);
                sequncerEngine.tracks[4].faderNode.gain.rampTo(1 - ratio, 0.01);
                */
                sequencerEngine.tracks[1].volumeNode.volume.rampTo(vol, 0.01);
            }
        }
    }, [setPart, part, sequencerEngine]);

    useEffect(() => {
        return () => {
            if (sequencerEngine) {
                sequencerEngine.dispose();
            }
        };
    }, [sequencerEngine]);

    useEffect(() => {
        if (!sequencerEngine || !sequencerEngine.tracks[0]) {
            return;
        }

        if (!props.toggled) {
            while(sequencerEngine.operationManager.executedActions.length > 0) {
                sequencerEngine.operationManager.undo();
            }
            flipSounds();
        }
        sequencerEngine.recording(props.toggled);
    }, [props.toggled, sequencerEngine]);

    let className = "landing-about";
    useEffect(() => {
        if (props.loading === 100) {
            flipSounds();
        }
    }, [props.loading, sequencerEngine]);

    const flipSounds = useCallback(() => {
        // audition the kick/hihat /rand
    }, [sequencerEngine]);

    let gridStyle = {
        //opacity: props.loading / 100.0
    };

    if (sequencerEngine && sequencerEngine.playing) {
        className += " playing";
    }
    return (
        <div className={className}>
          <div color="radial-gradient(75.29% 75.29% at 64.96% 24.36%, #F0DFA7 0.52%, #FDBDAA 18.75%, #FEA186 34.38%, #F09277 49.48%, #D27584 74.48%, #6B7B8A 100%)" className={"coke-machine-glow part-" + part}></div>
          <div className="market-row">
            <div>
              <div className="market-speak">
                BROWSER-BASED
              </div>
              <div className="market-speak">
                MUSIC-MAKING TOOL
              </div>
              <div className="market-speak">
                BUILT ON ETHEREUM
              </div>
            </div>
            {!sequencerEngine || !sequencerEngine.playing ?
             '' : <div onClick={pause} className="pause-button"></div>}
        </div>
          <div className="grids-container">
            <Grids onPlay={() => setPlay(true)} gridStyle={gridStyle} num={0} sequencerEngine={sequencerEngine}/>
            <Grids onPlay={() => setPlay(true)} gridStyle={gridStyle} num={1} sequencerEngine={sequencerEngine}/>
          </div>
          <img style={gridStyle} className="wavy" src="/wavy.svg"/>
          <div className="market-row">
            <div>
              <div className="market-speak">
                PERMANENT ARCHIVE
              </div>
              <div className="market-speak">
                4 OPERATOR FM 
              </div>
              <div className="market-speak">
                GENERATIVE CONTROL
              </div>
              <div className="market-speak">
                SAMPLE BAZAAR
              </div>
              <div className="market-speak">
                OPEN SOUND-DESIGN
              </div>
              <div className="market-speak">
                COLLABORATE AND SEE
              </div>
            </div>
            <div className="market-whisper">
              <p>
              </p>
              <p>
              </p>
            </div>
          </div>
          {sequencerEngine ? <StepsVisualizer sequencerEngine={sequencerEngine}/> : ''}
          <div className="bottom-space"/>
        </div>
    );
};

const Grids = ({gridStyle, sequencerEngine, num, onPlay}) => {
    let [pressed, setPressed] = useState(undefined);
    const [recordedTrigger, setRecordedTrigger] = useState(undefined);

    let lastNote = useRef(undefined);
    let rows = [1,2,3];
    let cols = [1,2,3];

    let hhTrack = sequencerEngine && sequencerEngine.tracks[6];
    let kickTrack = sequencerEngine && sequencerEngine.tracks[5];
    let synthTrack = sequencerEngine && sequencerEngine.tracks[0];

    const onClickGrid = useCallback((track, row, col) => {
        return;
        if (!sequencerEngine.playing) {
            sequencerEngine.play();
            onPlay();
        } 
        let stepData = new StepData();
        stepData.copyFrom(track.trackData);
        stepData.slice = 0;
        stepData.duration = null;
        let transpose = getTranspose(row , col + 3*num);
        if (track.trackNumber === 0) {
            if (transpose !== lastNote.current) {
                track.midiEffects.effects[0].enabledParameter.set(true);
            } else {
                track.midiEffects.effects[0].enabledParameter.set(false);
            }
        }
        stepData.transpose = transpose;
        stepData.velocity = 1;
        track.midiEffects.liveInputTrigger(stepData);
        setPressed({row, col});
        lastNote.current = transpose;

        if (sequencerEngine.isRecording) {
            setRecordedTrigger(new RecordedTrigger(
                track,
                0,
                RESOLUTION,
                track.sequencerEngine,
                true));
                
        }
    }, [sequencerEngine, setPressed, num, setRecordedTrigger]);

    const onReleaseGrid = useCallback((track, row, col) => {
        if (!sequencerEngine.playing) {
            return;
        }
        let transpose = getTranspose(row, col + 3*num);
        track.midiEffects.liveInputReleaseRealTime(transpose);
        if (track.instrument) {
            track.instrument.onPitchBend(0);
        }
        setPressed(undefined);
        if (recordedTrigger && sequencerEngine.isRecording) {
            recordedTrigger.record(
                sequencerEngine,
                track,
                transpose);
            setRecordedTrigger(undefined);
        }
    }, [sequencerEngine, setPressed, num, recordedTrigger, setRecordedTrigger]);

    const onMouseMove = useCallback((e) => {
        if (pressed) {
            let rect = e.target.getBoundingClientRect();
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;
            sequencerEngine.tracks[0].instrument.onPitchBend(y / 60.0);
        }
    }, [pressed, sequencerEngine]);


    return (
        <div style={gridStyle} className={"grids number-" + num}>
          {rows.map(
              row => <div className="grid-row">
                     {cols.map(
                         col =>
                             <Grid
                               key={getTranspose(row, col + 3*num)}
                               track={row === 2 && col === 1 ? kickTrack :
                                      row === 2 && col === 2 ? hhTrack :
                                      synthTrack}
                               onMouseMove={onMouseMove}
                               transpose={row === 2 && col === 1 && num === 0 ?
                                          0 : row === 2 && col === 1 && num === 1 ?
                                          9 : getTranspose(row, col + 3*num)}
                               num={num}
                               onClickGrid={onClickGrid}
                               onReleaseGrid={onReleaseGrid}
                               pressed={pressed}
                               row={row}
                               col={col}
                             />
                     )}
                   </div>)}
        </div>
    );
};

function getVolume(y, min=-40, max=4, height) {
    y = Math.min(Math.max(0, y), height);
    let ratio = y / height;
    let fullRatio = Math.pow(ratio, 0.5);
    return min + (max - min) * fullRatio;
}

const mapStateToProps = (state) => {
    
    let progress = state.sequencer.sequenceLoadingProgress;
    return {
        loading : progress[Object.keys(progress)[0]] || true
    };
};

export default connect(mapStateToProps, null)(LandingAbout);
